import { DateInput, InputField, Button, DataTable } from "@/components";
import { RightWrapper } from "../../../components";
import { useState, useCallback, useEffect } from "react";
import ColumnHelper from "@/utils/ColumnHelper";
import { useMemo } from "react";
import { useFilteredData } from "@/";
import { RiFileExcel2Line } from "react-icons/ri";
import { subDays } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { fetchShippingCharges } from "../../../app/slices";
const ShippingCharges = () => {
  const dateRange =
    useSelector((state) => state.dashboard?.data?.dateRange) || {};
  const currentDate = new Date();
  const startOfMonthDate = dateRange?.startDate
    ? new Date(dateRange.startDate)
    : subDays(currentDate, 30); // Last 30 days
  const endOfMonthDate = dateRange?.endDate
    ? new Date(dateRange.endDate)
    : currentDate;
  const [filters, setFilters] = useState({
    shippingId: "",
    date: { from: startOfMonthDate, to: endOfMonthDate },
  });

  const [appliedFilters, setAppliedFilters] = useState(filters);
  const [resetPageCounter, setResetPageCounter] = useState(0);
  const dispatch = useDispatch();
 const fetchData = async (params) => {
  const response = await dispatch(fetchShippingCharges(params));
  console.log("response::::::", response);
};
  useEffect(() => {
    if (!appliedFilters?.date?.from || !appliedFilters?.date?.to) return;

    fetchData({
      startDate: appliedFilters.date.from,
      endDate: appliedFilters.date.to,
    });
  }, [appliedFilters]);
  const ShippingCharges =
    useSelector((state) => state.shippingCharges?.shippingCharges) || [];
  const courier = useSelector((state) => state.app?.appData?.courier) || [];
  // Ensure rawData is only generated once
  // const rawData = useMemo(() => getShippingChargeData(100), []);

  // Filter configuration
  const filterConfig = useMemo(
    () => ({
      shippingId: {
        type: "comma",
        itemKey: "shippingId",
      },
      date: { type: "date", itemKey: "date" },
    }),
    []
  );

  // Memoize filtered data to prevent unnecessary re-renders
  const { data: finalFilteredData, isLoading } = useFilteredData(
    ShippingCharges,
    appliedFilters,
    filterConfig
  );
  const IsLoadingShippingCharges = useSelector(
    (state) => state.shippingCharges.loading
  );
  const isShippingChargeLoading = isLoading || IsLoadingShippingCharges;
  // Format currency values
  const formatCurrency = useCallback((value) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(value);
  }, []);

  // Format date values
  const formatDate = useCallback((dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }, []);
  // Memoized table columns
  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "Date",
        accessorKey: "date",
        cell: (info) => formatDate(info.row.original.date),
        meta: {
          tooltip: (row) => formatDate(row.date),
        },
      }),
      ColumnHelper({
        header: "Shipping ID",
        accessorKey: "shippingId",
        meta: {
          tooltip: (row) => row.shippingId || "N/A",
        },
      }),
      ColumnHelper({
        header: "Courier Partner",
        accessorKey: "CourierPartner",
        cell: (info) => {
          const partner = courier.find(
            (c) => c._id === info.row.original.CourierPartner
          )?.name;
          return partner;
        },
        meta: {
          tooltip: (row) => {
            const partnerName = courier.find(
              (c) => c._id === row.CourierPartner
            )?.name;
            return partnerName;
          },
        },
      }),
      ColumnHelper({
        header: "Product Name",
        accessorKey: "Products",
        cell: (info) => {
          const productsArray = info.row.original.Products || []; // Ensure it's an array
          const products = productsArray
            .map((product) => product.productName) // Extract productName
            .join(", ");
          return <span>{products}</span>;
        },
        meta: {
          tooltip: (row) => {
            const productsArray = row.Products || []; // Adjusted to match API response
            return productsArray.map((p) => p.productName).join(", ");
          },
        },
      }),
      ColumnHelper({
        header: "Status",
        accessorKey: "Status",
        meta: {
          tooltip: (row) => row.Status || "N/A",
        },
      }),
      ColumnHelper({
        header: "Freight Charges",
        accessorKey: "FreightCharge",
        cell: (info) => (
          <span className="font-nunito">
            {formatCurrency(info.row.original.FreightCharge)}
          </span>
        ),
        meta: {
          tooltip: (row) => (
            <span className="font-nunito">
              {formatCurrency(row.FreightCharge)}
            </span>
          ),
        },
      }),
      ColumnHelper({
        header: "COD Charges",
        accessorKey: "CodCharge",
        cell: (info) => (
          <span className="font-nunito">
            {formatCurrency(info.row.original.CodCharge)}
          </span>
        ),
        meta: {
          tooltip: (row) => (
            <span className="font-nunito">{formatCurrency(row.CodCharge)}</span>
          ),
        },
      }),
      ColumnHelper({
        header: "Entered Weight",
        accessorKey: "enteredWeight",
        cell: (info) => `${info.row.original.enteredWeight} kg`,
        meta: {
          tooltip: (row) => `${row.enteredWeight} kg`,
        },
      }),
      ColumnHelper({
        header: "Enter Dimension",
        accessorKey: "enteredDimension",
        cell: (info) => {
          const dimension = info.row.original.enteredDimension;

          return dimension
            ? `${dimension.length} x ${dimension.breadth} x ${dimension.height}`
            : "N/A";
        },
        meta: {
          tooltip: (row) => {
            const dimension = row.enteredDimension;
            return dimension
              ? `L: ${dimension.length}, B: ${dimension.breadth}, H: ${dimension.height}`
              : "No dimensions available";
          },
        },
      }),

      ColumnHelper({
        header: "Applied Weight",
        accessorKey: "appliedWeight",
        cell: (info) => `${info.row.original.appliedWeight} kg`,
        meta: {
          tooltip: (row) => `${row.appliedWeight} kg`,
        },
      }),
      ColumnHelper({
        header: "Final Weight",
        accessorKey: "finalWeight",
        cell: (info) =>
          `${info.row?.original?.finalWeight || info.row.original.appliedWeight
          } kg`,
        meta: {
          tooltip: (row) => `${row?.finalWeight || row?.appliedWeight} kg`,
        },
      }),
      ColumnHelper({
        header: "Extra Weight Charges",
        accessorKey: "extraWeightCharge",
        cell: (info) => (
          <span className="font-nunito">
            {formatCurrency(info.row.original.extraWeightCharge)}
          </span>
        ),
        meta: {
          tooltip: (row) => (
            <span className="font-nunito">
              {formatCurrency(row.extraWeightCharge)}
            </span>
          ),
        },
      }),
      ColumnHelper({
        header: "Refund Extra Weight Charges",
        accessorKey: "refundExtraWeightCharge",
        cell: (info) => (
          <span className="font-nunito">
            {isNaN(info.row.original.refundExtraWeightCharge)
              ? formatCurrency(0)
              : formatCurrency(info.row.original.refundExtraWeightCharge)}
          </span>
        ),
        meta: {
          tooltip: (row) => (
            <span className="font-nunito">
              {isNaN(row.refundExtraWeightCharge)
                ? formatCurrency(0)
                : formatCurrency(row.refundExtraWeightCharge)}
            </span>
          ),
        },
      }),
      ColumnHelper({
        header: "COD Charges Reversed",
        accessorKey: "codChargeReversed",
        cell: (info) => (
          <span className="font-nunito">
            {formatCurrency(info.row.original.codChargeReversed)}
          </span>
        ),
        meta: {
          tooltip: (row) => (
            <span className="font-nunito">
              {formatCurrency(row.codChargeReversed)}
            </span>
          ),
        },
      }),
      ColumnHelper({
        header: "RTO Charges",
        accessorKey: "rtoCharge",
        cell: (info) => (
          <span className="font-nunito">
            {formatCurrency(info.row.original.rtoCharge)}
          </span>
        ),
        meta: {
          tooltip: (row) => (
            <span className="font-nunito">{formatCurrency(row.rtoCharge)}</span>
          ),
        },
      }),
      ColumnHelper({
        header: "RTO Extra Weight Charges",
        accessorKey: "rtoExtraWeightCharge",
        cell: (info) => (
          <span className="font-nunito">
            {formatCurrency(info.row.original.rtoExtraWeightCharge)}
          </span>
        ),
        meta: {
          tooltip: (row) => (
            <span className="font-nunito">
              {formatCurrency(row.rtoExtraWeightCharge)}
            </span>
          ),
        },
      }),
      ColumnHelper({
        header: "Total",
        accessorKey: "total",
        cell: (info) => (
          <span className="font-nunito">
            {formatCurrency(info.row.original.total)}
          </span>
        ),
        meta: {
          tooltip: (row) => (
            <span className="font-nunito">{formatCurrency(row.total)}</span>
          ),
        },
      }),
    ],
    [courier] // Ensure dependencies are correct
  );

  // Handle filter changes
  const handleChange = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const handleDateChange = useCallback((dateRange) => {
    setFilters((prev) => ({
      ...prev,
      date: { from: dateRange?.from || "", to: dateRange?.to || "" },
    }));
  }, []);

  // Apply filters without resetting raw data
  const handleApply = useCallback(() => {
    setAppliedFilters(filters);
    setResetPageCounter((prev) => prev + 1);
  }, [filters]);

  // Reset filters properly
 const handleReset = useCallback(() => {
  const initialFilters = {
    shippingId: "",
    date: { from: startOfMonthDate, to: endOfMonthDate },
  };

  setFilters(initialFilters);
  setAppliedFilters(initialFilters);
  setResetPageCounter((prev) => prev + 1);
}, [startOfMonthDate, endOfMonthDate]);

  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 mt-2 px-2 relative pb-20 md:pb-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 items-end">
          <DateInput
            label="Date Filter"
            placeholder="Select From & To date"
            mode="range"
            value={filters.date}
            onChange={handleDateChange}
          />
          <InputField
            label="Shipping ID"
            placeholder="Enter Shipping ID"
            type="text"
            name="shippingId"
            value={filters.shippingId}
            onChange={(value) => handleChange("shippingId", value)}
          />
          <div className="flex gap-2 justify-end md:justify-start">
            <Button variant="default" size="md" onClick={handleApply}>
              Apply
            </Button>
            <Button variant="outline" size="md" onClick={handleReset}>
              Reset
            </Button>
          </div>
        </div>
        <DataTable
          columns={columns}
          tittle="Shipping Charges"
          data={finalFilteredData}
          showCheckbox={false}
          isLoading={isShippingChargeLoading}
          resetPage={resetPageCounter}
          actions={[
            {
              name: "Export",
              onClick: () => { },
              icon: RiFileExcel2Line,
              body: {
                model: "Shipping Charges",
                filename: `shipping_charges${new Date().getTime()}`,
              },
            },
          ]}
        />
      </div>
    </RightWrapper>
  );
};

export default ShippingCharges;
